// Plain-language privacy policy and terms — required by the Teams store,
// Chrome Web Store, and Edge Add-ons listings, and true regardless.
import React from 'react';

const wrap = {
  maxWidth: 720,
  margin: '0 auto',
  padding: '48px 24px',
  fontFamily: "-apple-system, 'Segoe UI', Roboto, sans-serif",
  color: '#1e293b',
  lineHeight: 1.7,
};
const h1 = { fontSize: 28, marginBottom: 4 };
const h2 = { fontSize: 18, marginTop: 28, marginBottom: 6 };
const muted = { color: '#64748b', fontSize: 14 };

export function Privacy() {
  return (
    <div style={wrap}>
      <h1 style={h1}>AuthenIQ Privacy Policy</h1>
      <p style={muted}>Effective August 29, 2026</p>
      <h2 style={h2}>What AuthenIQ does</h2>
      <p>
        AuthenIQ verifies that participants in virtual environments are live humans. When
        invited into a meeting, it issues short verification codes in the meeting chat and
        records whether each participant responds correctly.
      </p>
      <h2 style={h2}>What we collect</h2>
      <p>
        For a verified session we process participant display names, meeting join events,
        chat replies to our verification codes, and derived verification signals. If you
        create an account we store your email address and, for social sign-in, the name and
        photo your provider shares. We do not record meeting audio or video content for
        playback, and we do not sell personal data.
      </p>
      <h2 style={h2}>How it is used</h2>
      <p>
        Verification data is used to show live trust status to the people in that session
        and to improve the accuracy of verification. Data is transmitted over TLS and
        stored in access-controlled infrastructure in the United States.
      </p>
      <h2 style={h2}>Your choices</h2>
      <p>
        Verification is visible: codes and results appear in the meeting itself. To have
        account or session data deleted, contact us and we will remove it.
      </p>
      <h2 style={h2}>Contact</h2>
      <p>amotley@autheniq.ai · AuthenIQ, Washington, DC</p>
    </div>
  );
}

export function Terms() {
  return (
    <div style={wrap}>
      <h1 style={h1}>AuthenIQ Terms of Use</h1>
      <p style={muted}>Effective August 29, 2026</p>
      <h2 style={h2}>The service</h2>
      <p>
        AuthenIQ provides live human verification for virtual environments. During the
        beta the service is provided free of charge, as is, and without warranty of any
        kind. Verification is a risk signal, not a guarantee of identity.
      </p>
      <h2 style={h2}>Acceptable use</h2>
      <p>
        Only deploy AuthenIQ into meetings and environments you are authorized to join.
        Do not use the service to harass participants, to collect data about people
        without a legitimate basis, or to misrepresent verification results.
      </p>
      <h2 style={h2}>Accounts</h2>
      <p>
        You are responsible for activity under your account. We may suspend accounts that
        abuse the service. Enterprise licensing is available separately.
      </p>
      <h2 style={h2}>Liability</h2>
      <p>
        To the maximum extent permitted by law, AuthenIQ is not liable for indirect or
        consequential damages arising from use of the service.
      </p>
      <h2 style={h2}>Contact</h2>
      <p>amotley@autheniq.ai · AuthenIQ, Washington, DC</p>
    </div>
  );
}
